/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Section_CarrierInputs */

const vi_cdo_section_carrier = /** @type {(inputs: Cdo_Section_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị giao`)
};

/**

* @param {Cdo_Section_CarrierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_section_carrier = /** @type {((inputs?: Cdo_Section_CarrierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Section_CarrierInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_section_carrier(inputs)
});